import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_ABONOS_DESGLOSE_VENTAS_OCUPACION_SECTORES_PRECIOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.desglose-ventas.ocupacion-sectores-precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_DESGLOSE_VENTAS_OCUPACION_PRECIOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.desglose-ventas.ocupacion-precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_DESGLOSE_VENTAS_RECAUDACION_SECTORES_PRECIOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.desglose-ventas.recaudacion-sectores-precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_DESGLOSE_VENTAS_RECAUDACION_PRECIOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.desglose-ventas.recaudacion-precios'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_ABONOS_DESGLOSE_VENTAS_RECAUDACION_CUPONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.abonos.desglose-ventas.recaudacion-cupones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};
